import { createTheme } from '@mui/material'
import { Theme, Shadows } from '@mui/material/styles'

export const MAX_CONTAINER_WIDTH = 768
export const BUTTON_WIDTH = 332

export const SELECTED_BORDER = (theme: Theme) => `2px solid ${theme.palette.primary['800']}`

export const shadows = [
  ...createTheme({}).shadows.map((shadow, index) => {
    switch (index) {
      case 1:
        return '0px -0.5px 0.5px rgba(0, 0, 0, 0.1), 0px 0.5px 1px rgba(0, 0, 0, 0.35);'
      case 2:
        return '0px 0px 8px rgba(33, 33, 33, 0.08), 0px 1px 1px rgba(33, 33, 33, 0.06);'
      case 3:
        return '0px 0px 10px rgba(33, 33, 33, 0.1), 0px 1px 1px rgba(33, 33, 33, 0.06);'
      case 4:
        return '0px 5px 10px rgba(33, 33, 33, 0.1), 0px 2px 4px rgba(33, 33, 33, 0.16);'
      case 5:
        return '0px 0px 24px rgba(33, 33, 33, 0.2), 0px 2px 4px rgba(33, 33, 33, 0.16);'
      case 6:
        return '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15);'
      case 7:
        return '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15);'
      case 8:
        return '0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3);'
      case 9:
        return '0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3);'
      case 10:
        return '0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3);'
      default:
        return shadow
    }
  }),
] as Shadows
